import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, CheckIcon, CircleDashedIcon, LinkedinIcon } from 'lucide-react';
import { LenticMark } from '../components/LenticMark';
import { EYEBROW } from '../components/site/Band';
import { companyIntro, evidenceEstablished, evidenceInProgress, founders } from '../data/site';
export function Company() {
  return <>
      <section className="relative w-full overflow-hidden border-b border-mist bg-bone" data-id="element-425" data-mp="gi9t3cuh2zya">
        <div className="pointer-events-none absolute -right-40 -top-32 opacity-[0.12] lg:-right-20" data-id="element-426" data-mp="gkmiuc6h2elw">
          <LenticMark size={560} title={null} data-id="element-427" data-mp="qgfrhkh2lnye" />
        </div>

        <div className="relative mx-auto w-full max-w-6xl px-6 py-24 lg:px-10 lg:py-32" data-id="element-428" data-mp="qeuxpx2ky91l">
          <p className={`${EYEBROW} text-teal`} data-id="element-429" data-mp="vgagtjl765hc">Company</p>
          <h1 className="mt-5 max-w-3xl font-display text-[40px] font-light leading-[1.05] tracking-tight text-ink sm:text-[56px]" data-id="element-430" data-mp="21vuy7fz2zu6p">
            What we're building.
          </h1>
          <div className="mt-8 max-w-[68ch] space-y-5" data-id="element-431" data-mp="26wiqs62ykj31">
            {companyIntro.map(line => <p key={line} className="text-xl leading-relaxed text-graphite" data-id="element-432" data-mp="2a8n39hsq2v6d">
                {line}
              </p>)}
          </div>
        </div>
      </section>

      <section className="w-full border-b border-mist bg-bone" data-id="element-433" data-mp="217p1751ugxqf">
        <div className="mx-auto w-full max-w-6xl px-6 py-24 lg:px-10 lg:py-32" data-id="element-434" data-mp="1w9x8w9xaf9lp">
          <p className={`${EYEBROW} text-teal`} data-id="element-435" data-mp="1wbzvsl358mm7">Founders</p>
          <h2 className="mt-5 font-display text-[34px] font-light leading-[1.08] tracking-tight text-ink sm:text-5xl" data-id="element-436" data-mp="1rbc8oai1cpx9">
            Who is doing the work.
          </h2>

          <ul className="mt-12 grid gap-4 md:grid-cols-2" data-id="element-437" data-mp="1hk98dawxkez1">
            {founders.map(person => <li key={person.background} className="flex flex-col rounded-2xl border border-mist bg-white/70 p-8" data-id="element-438" data-mp="1dj5omdbrhysj">
                <span className="font-mono text-xs uppercase tracking-[0.2em] text-teal" data-id="element-439" data-mp="18km2ocx64n06">
                  {person.role}
                </span>
                <h3 className="mt-4 font-display text-2xl font-medium text-ink" data-id="element-440" data-mp="13lrm7hmobaj8">
                  {person.name}
                </h3>
                <p className="mt-3 max-w-[46ch] text-lg leading-relaxed text-graphite" data-id="element-441" data-mp="ywgqofx5rto9">
                  {person.background}
                </p>
                <a href={person.linkedin} target="_blank" rel="noreferrer" className="mt-6 inline-flex items-center gap-2 text-[15px] font-semibold text-ink transition-colors hover:text-teal" data-id="element-442" data-mp="k0hmhgd66doe">
                  <LinkedinIcon className="h-4 w-4" aria-hidden="true" data-id="element-443" data-mp="1cp6gkvft5iqn" />
                  LinkedIn
                </a>
              </li>)}
          </ul>
        </div>
      </section>

      <section className="w-full border-b border-mist bg-bone" data-id="element-444" data-mp="12ytyd9vgu1no">
        <div className="mx-auto w-full max-w-6xl px-6 py-24 lg:px-10 lg:py-32" data-id="element-445" data-mp="12w7p95sxfe3c">
          <p className={`${EYEBROW} text-teal`} data-id="element-446" data-mp="17vbx9t4475s3">Where we are</p>
          <h2 className="mt-5 max-w-3xl font-display text-[34px] font-light leading-[1.08] tracking-tight text-ink sm:text-5xl" data-id="element-447" data-mp="1vlofbwt2qiwe">
            Early, and specific about it.
          </h2>
          <p className="mt-6 max-w-[68ch] text-xl leading-relaxed text-graphite" data-id="element-448" data-mp="3l337og1hu6of">
            Stating exactly where the evidence stops is part of the product
            argument, not a caveat attached to it.
          </p>

          <div className="mt-12 grid gap-4 lg:grid-cols-2" data-id="element-449" data-mp="3usd1q1fwdzf6">
            <div className="rounded-2xl border border-teal/30 bg-teal/[0.05] p-8 lg:p-10" data-id="element-450" data-mp="3putj6pc630hf">
              <h3 className="font-mono text-xs uppercase tracking-[0.2em] text-teal" data-id="element-451" data-mp="324qxcqyuiqr9">
                Established
              </h3>
              <ul className="mt-7 space-y-5" data-id="element-452" data-mp="2x6xr5xxjlwqz">
                {evidenceEstablished.map(item => <li key={item} className="flex items-start gap-3" data-id="element-453" data-mp="3b66ye83rtgit">
                    <CheckIcon className="mt-1.5 h-4 w-4 shrink-0 text-teal" aria-hidden="true" data-id="element-454" data-mp="3b3cechoo5xpx" />
                    <span className="max-w-[52ch] text-lg leading-relaxed text-ink" data-id="element-455" data-mp="376g9k9xt1agx">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>

            <div className="rounded-2xl border border-mist bg-white/60 p-8 lg:p-10" data-id="element-456" data-mp="mg7b8brsys83">
              <h3 className="font-mono text-xs uppercase tracking-[0.2em] text-graphite" data-id="element-457" data-mp="1hq4816jf95b5">
                In progress
              </h3>
              <ul className="mt-7 space-y-5" data-id="element-458" data-mp="1qo6fa3tr0u6v">
                {evidenceInProgress.map(item => <li key={item} className="flex items-start gap-3" data-id="element-459" data-mp="1vnsrqb1r66em">
                    <CircleDashedIcon className="mt-1.5 h-4 w-4 shrink-0 text-muted" aria-hidden="true" data-id="element-460" data-mp="1vp3uq8ndja4o" />
                    <span className="max-w-[52ch] text-lg leading-relaxed text-graphite" data-id="element-461" data-mp="20mnbbf7jnyzs">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </div>

          <p className="mt-10 max-w-[70ch] font-display text-2xl font-light leading-snug text-ink" data-id="element-462" data-mp="29hjtgx98slzs">
            We publish the analysis plan before we run it, and we report the
            cases where the assessment failed to discriminate.
          </p>
        </div>
      </section>

      <section className="w-full border-b border-mist bg-bone" data-id="element-463" data-mp="2oadj3bi8aii6">
        <div className="mx-auto grid w-full max-w-6xl gap-10 px-6 py-24 lg:grid-cols-[1fr_1fr] lg:items-center lg:px-10 lg:py-32" data-id="element-464" data-mp="cq613vt00qii">
          <div data-id="element-465" data-mp="7s4fb346ud3c">
            <p className={`${EYEBROW} text-teal`} data-id="element-466" data-mp="2qylt32pelsr">Contact</p>
            <h2 className="mt-5 font-display text-[34px] font-light leading-[1.08] tracking-tight text-ink sm:text-5xl" data-id="element-467" data-mp="2rgq8mzis6br">
              Talk to us directly.
            </h2>
            <p className="mt-6 max-w-[52ch] text-xl leading-relaxed text-graphite" data-id="element-468" data-mp="vfvse8xjyu5o">
              Operating buyers, candidates and investors all reach us at the
              same address.
            </p>
          </div>

          <div className="rounded-2xl border border-mist bg-white/70 p-8" data-id="element-469" data-mp="lohuu6p5w4f6">
            <a href="mailto:hello@lentic.ai" className="font-display text-2xl text-ink transition-colors hover:text-teal" data-id="element-470" data-mp="grhpjy04z5p4">
              hello@lentic.ai
            </a>
            <p className="mt-3 text-[15px] text-graphite" data-id="element-471" data-mp="19fdnf61fz3nh">
              London, United Kingdom
            </p>
            <Link to="/#contact" className="mt-8 inline-flex items-center gap-2 rounded-full bg-ink px-6 py-3.5 text-base font-semibold text-bone transition-colors hover:bg-teal" data-id="element-472" data-mp="33nhbxhwhkckz">
              See pilot pricing
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-473" data-mp="2ty7nqd4rje25" />
            </Link>
          </div>
        </div>
      </section>
    </>;
}